import React from 'react';
import { map } from 'lodash';

export const FormErrorMessage = ({
  error,
  touched,
}) => {
  if (!error || !touched) return null;

  return (
    <div className="cu-ui-form-errors">
      { map(error, (errMsg,idx) => (
        <p key={idx + errMsg}>
          { errMsg }
        </p>
      ))}
    </div>
  );
};
